import { Button, Card, Typography } from 'antd';
import { CirclePlay as CirclePlayIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useAppSelector } from '@/store/hooks';
import { DEMO_HERO_PROPOSAL_ID, DEMO_VAULT_IDS } from './demoFixtures';
import './demo.css';

const { Text, Title } = Typography;

/**
 * Demo-dashboard entry point to the signature walkthrough. Self-gates on
 * `auth.isDemo` (renders nothing otherwise) and deep-links to the hero payroll
 * proposal where the inline walkthrough lives (DEMO_TREASURY_DESIGN.md §5.4).
 * Imports nothing from the signing/wallet layer.
 */
export function DemoWalkthroughCta() {
  const isDemo = useAppSelector((state) => state.auth.isDemo);
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!isDemo) return null;

  return (
    <Card
      style={{ marginBottom: 16, borderColor: '#fbbf24' }}
      styles={{ body: { display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' } }}
    >
      <div style={{ flex: '1 1 240px', minWidth: 0 }}>
        <Title level={5} className="font-display" style={{ margin: 0 }}>
          {t('demo.walkthroughCta')}
        </Title>
        <Text type="secondary">{t('demo.simulatedHeader')}</Text>
      </div>
      <Button
        type="primary"
        icon={<CirclePlayIcon />}
        data-testid="demo-dashboard-walkthrough-cta"
        onClick={() => {
          void navigate(`/vaults/${DEMO_VAULT_IDS.eth}/proposals/${DEMO_HERO_PROPOSAL_ID}`);
        }}
      >
        {t('demo.walkthroughCta')}
      </Button>
    </Card>
  );
}

export default DemoWalkthroughCta;
